import { motion } from "framer-motion";
import { CalendarDaysIcon } from "@heroicons/react/24/solid";

export default function FloatingAppointmentBtn() {
    return (
        <a
            href="https://wa.me/919159038012?text=Hello,%20I%20would%20like%20to%20book%20an%20appointment.%20My%20preferred%20date%20is:%20_________%20and%20time%20is:%20_________"
            target="_blank"
            rel="noopener noreferrer"
        >
            <motion.div
                className="fixed bottom-6 right-6 z-50 group flex items-center justify-center p-4 bg-indigo-600 text-white rounded-full shadow-lg hover:bg-indigo-500 cursor-pointer"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
            >
                <div className="absolute inset-0 rounded-full bg-indigo-400 opacity-75 animate-ping"></div>
                <CalendarDaysIcon className="h-6 w-6 sm:h-8 sm:w-8 relative z-10" />
                <span className="ml-2 font-semibold hidden group-hover:block transition-all duration-300 relative z-10 whitespace-nowrap">
                    Book Appointment
                </span>
            </motion.div>
        </a>
    );
}
